import React from 'react';
import { Spacer } from '../../../components/layout/spacers';
import { TBody, TImage } from '../../../components/template';

export const ImageBodyWidget = React.memo(({ image, body }) => (
  <>
    {image && <TImage src={image} />}
    <Spacer type='component' />
    <TBody html={body} />
  </>
));
